export const areStatusCodesInvalid = (bidStatusCode: boolean, askStatusCode: boolean): boolean => {
  return [bidStatusCode, askStatusCode].every((status) => !status);
};
